import { defineComponent as f, inject as v, ref as w, onBeforeUnmount as z, h as R } from "vue";
import { dataTableInjectionKey as h } from "./ghl-ui.es992.js";
import { off as a, on as d } from "./ghl-ui.es739.js";
const g = f({
  name: "ColumnResizeButton",
  props: {
    onResizeStart: Function,
    onResize: Function,
    onResizeEnd: Function
  },
  setup(n) {
    const {
      mergedClsPrefixRef: r
    } = v(h), t = w(!1);
    let s = 0;
    function l(e) {
      return e.clientX;
    }
    function c(e) {
      var o;
      e.preventDefault();
      const m = t.value;
      s = l(e), t.value = !0, m || (d("mousemove", window, i), d("mouseup", window, u), (o = n.onResizeStart) === null || o === void 0 || o.call(n));
    }
    function i(e) {
      var o;
      (o = n.onResize) === null || o === void 0 || o.call(n, l(e) - s);
    }
    function u() {
      var e;
      t.value = !1, (e = n.onResizeEnd) === null || e === void 0 || e.call(n), a("mousemove", window, i), a("mouseup", window, u);
    }
    return z(() => {
      a("mousemove", window, i), a("mouseup", window, u);
    }), {
      mergedClsPrefix: r,
      active: t,
      handleMousedown: c
    };
  },
  render() {
    const {
      mergedClsPrefix: n
    } = this;
    return R("span", {
      "data-data-table-resizable": !0,
      class: [`${n}-data-table-resize-button`, this.active && `${n}-data-table-resize-button--active`],
      onMousedown: this.handleMousedown
    });
  }
});
export {
  g as default
};
